enum UIShowViewName {
  TICKET_CHECK = 'TicketCheck',
  INSTRUCTIONS = 'Instructions',
  RESULTS = 'Results',
  BETTING_AREA = 'BettingArea',
}

export default UIShowViewName;
